import { render, staticRenderFns } from "./VideoListCard.vue?vue&type=template&id=239fce05&scoped=true&"
import script from "./VideoListCard.vue?vue&type=script&lang=js&"
export * from "./VideoListCard.vue?vue&type=script&lang=js&"
import style0 from "./VideoListCard.vue?vue&type=style&index=0&id=239fce05&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "239fce05",
  null
  
)

export default component.exports